function filterData(searchTxt, restaurants) {
     const filterData = restaurants.filter((e) =>
          e?.info?.name?.toLowerCase()?.includes(searchTxt.toLowerCase())
     );
     return filterData;
}
export default filterData;